import { Icon as r } from "../../../components/Icon/index.js";
import { styled as o } from "styled-components";
import { Colors as t } from "../../../styles/colors/index.js";
import { Theme as i } from "../../../styles/themes/index.js";
import { CaptionHeavy as e } from "../../../styles/typography/index.js";
import { MediaQuery as n } from "../../../styles/variables.js";
const m = o(r)`
  font-size: 24px;
`, d = o.button`
  background-color: rgb(${i.colors.Juliet});
  display: flex;
  align-items: center;

  ${m} {
    color: rgb(${t.Alien});
  }

  @media ${n.SCREEN_MD_UP} {
    display: none;
  }
`, g = o.div`
  ${e}
  margin-left: 4px;
`;
export {
  d as Container,
  g as Title,
  m as WhatsAppIcon
};
